'use strict';

$(document).ready(function () {

    $('body').on('submit', 'form.trackorder', function (e) {
        e.preventDefault();
        var $form = $(this);
        var url = $form.attr('action');
        $form.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    if ($('.error-control').hasClass('d-none')) {
                        $('.error-control').removeClass('d-none');
                    }
                    $('.error-feedback').html('<strong>' + data.errorMessage + '</strong>');
                } else {
                    location.replace(data.redirectUrl);
                }
            },
            error: function (e) {
                $form.spinner().stop();
            }
        });
    });
});